import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { USER_KEY } from './keys';
import { EnrollApi } from 'api';
import { SearchEnrollQueryByUserType } from 'types';

function useGetAllByUser(query: SearchEnrollQueryByUserType) {
  return useAuthQuery(
    getQueryKeys([USER_KEY]).list({ ...query }),
    () => EnrollApi.getAllByUserId(query),
    {
      select: (data) => data.data,
    },
  );
}

export default useGetAllByUser;
